// Kontaktní osoba v hlavičce — fotka se stavem online/offline, telefon a otevírací doba.
// Vkládá se dvakrát: do hlavičky (desktop) a jako položka hamburger menu (mobil). Která verze je vidět,
// řídí CSS podle breakpointu. Vše (texty, rozvrh, zapnutí) je v shopDataLayer.headerContact.

const HEADER_CONTACT_TIMEZONE = "Europe/Prague";
const HEADER_CONTACT_WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

// Den v týdnu (0 = neděle) a minuty od půlnoci v pražském čase, nezávisle na zóně prohlížeče
function getPragueTime(date) {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: HEADER_CONTACT_TIMEZONE,
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
    }).formatToParts(date);

    const values = {};
    parts.forEach(function (part) {
        values[part.type] = part.value;
    });

    return {
        day: HEADER_CONTACT_WEEKDAYS[values.weekday],
        minutes: parseInt(values.hour, 10) * 60 + parseInt(values.minute, 10),
    };
}

function timeToMinutes(time) {
    const parts = String(time).split(":");
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1] || 0, 10);
}

// Online = od otevření (včetně) do zavření (vyjma). Den bez rozvrhu = offline.
function isHeaderContactOnline(schedule, date) {
    const now = getPragueTime(date || new Date());
    const range = schedule ? schedule[now.day] : null;

    if (!range || range.length < 2) {
        return false;
    }

    return now.minutes >= timeToMinutes(range[0]) && now.minutes < timeToMinutes(range[1]);
}

// Vloží položku do hamburger menu nad první nalezenou položku z shopDataLayer.header.mobileMenu
// (Blog, Kontakty), jinak na konec menu. Používá i tlačítko nabídky pro podnikatele v main.js.
window.myInsertIntoMobileMenu = function ($item) {
    const $menu = $("#navigation .menu-level-1");
    const mobileMenu = window.shopDataLayer && window.shopDataLayer.header && window.shopDataLayer.header.mobileMenu;
    const selectors = (mobileMenu && mobileMenu.insertBefore) || [];
    let $anchor = $();

    selectors.some(function (selector) {
        $anchor = $menu.children(selector).first();
        return $anchor.length > 0;
    });

    if ($anchor.length) {
        $item.insertBefore($anchor);
    } else {
        $item.appendTo($menu);
    }
};

function buildHeaderContact(config, modifier) {
    const $block = $("<div class='myheader-contact myheader-contact--" + modifier + "'></div>");
    const altText = config.role ? config.name + ", " + config.role : config.name;

    const $photo = $("<a class='myheader-contact-photo'></a>")
        .attr("href", config.phone.link)
        .attr("aria-label", config.phone.text);

    $("<img>")
        .attr("src", config.photo)
        .attr("alt", altText)
        .attr("width", 50)
        .attr("height", 50)
        .attr("loading", modifier === "menu" ? "lazy" : "eager")
        .appendTo($photo);

    $("<span class='myheader-contact-status'></span>").appendTo($photo);

    const $info = $("<div class='myheader-contact-info'></div>");

    $("<a class='myheader-contact-phone'></a>")
        .attr("href", config.phone.link)
        .text(config.phone.text)
        .appendTo($info);

    $("<span class='myheader-contact-hours'></span>")
        .text(config.hoursText)
        .appendTo($info);

    return $block.append($photo).append($info);
}

function updateHeaderContactStatus() {
    const config = window.shopDataLayer && window.shopDataLayer.headerContact;
    if (!config) {
        return;
    }

    const online = isHeaderContactOnline(config.schedule);

    $(".myheader-contact")
        .toggleClass("is-online", online)
        .toggleClass("is-offline", !online)
        .find(".myheader-contact-status")
        .text(online ? config.statusOnline : config.statusOffline);
}

function initHeaderContact() {
    const config = window.shopDataLayer && window.shopDataLayer.headerContact;
    if (!config || !config.enabled) {
        return;
    }

    // Hlavička — mezi vyhledávání a tlačítka
    if ($("#header .header-top").length && $("#header .myheader-contact--header").length === 0) {
        const $header = buildHeaderContact(config, "header");
        const $search = $("#header .header-top > .search");

        if ($search.length) {
            $header.insertAfter($search);
        } else {
            $header.insertBefore("#header .header-top > .navigation-buttons");
        }
    }

    // Hamburger menu — pod tlačítko nabídky pro podnikatele, nad Blog a Kontakty
    if ($("#navigation .menu-level-1").length && $("#navigation .myheader-contact--menu").length === 0) {
        const $item = $("<li class='nav-contact-item'></li>").append(buildHeaderContact(config, "menu"));
        const $firmyItem = $("#navigation .menu-level-1 > .nav-firmy-btn");

        if ($firmyItem.length) {
            $item.insertAfter($firmyItem);
        } else {
            window.myInsertIntoMobileMenu($item);
        }
    }

    updateHeaderContactStatus();

    // Přepočet srovnaný na celou minutu: první na začátku další minuty, pak každých 60 s (jen jednou)
    if (!window.myHeaderContactTimer) {
        const now = new Date();
        const toNextMinute = 60000 - (now.getSeconds() * 1000 + now.getMilliseconds());

        window.myHeaderContactTimer = setTimeout(function () {
            updateHeaderContactStatus();
            window.myHeaderContactInterval = setInterval(updateHeaderContactStatus, 60000);
        }, toNextMinute);
    }
}

$(document).ready(function () {
    initHeaderContact();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    initHeaderContact();
});
